var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-14 left-0 right-0 w-screen z-40"},[_c('div',{staticClass:"flex flex-col gap-2"},_vm._l((_vm.messages),function(messageObj){return _c('div',{key:messageObj.id},[_c('NotificationItem',{attrs:{"message":messageObj.message,"type":messageObj.type,"id":messageObj.id},on:{"close":_vm.onClose}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }